module.exports = __webpack_public_path__ + "img/down-from-line.0cba134f.svg";